import SearchText from "@components/common/search-text";
import { PeekStack } from "@piiqtechnologies/ui-components";
import { DxServices, useDxSettings, useError, useLoader } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import CreateAccessDevice from "../sgt-table-actions/create-access-device/CreateAccessDevice";
import ImportAccessDevices from "../sgt-table-actions/import-access-devices/ImportAccessDevices";
import messages from "./messages.i18n";
export const AccessDevicesTabAction = ({ searchText, setSearchText, community, proxyUser, }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [getDxSettings, dxSettings, isLoading, error] = useDxSettings();
    const isSeamAvailable = useMemo(() => {
        return dxSettings === null || dxSettings === void 0 ? void 0 : dxSettings.find((dx) => dx.service === DxServices.SEAM && !!dx.communityId);
    }, [dxSettings]);
    useEffect(() => {
        if (!(community === null || community === void 0 ? void 0 : community._id))
            return;
        getDxSettings({ communityId: community === null || community === void 0 ? void 0 : community._id });
    }, [community === null || community === void 0 ? void 0 : community._id]);
    useEffect(() => {
        if (error) {
            setError(error === null || error === void 0 ? void 0 : error.message);
        }
    }, [error]);
    useEffect(() => {
        setLoader(isLoading);
        return () => setLoader(false);
    }, [isLoading]);
    return (React.createElement(PeekStack, { spacing: 2, direction: "row" },
        React.createElement(SearchText, { searchText: searchText, onChange: setSearchText, placeholder: intl.formatMessage(messages.accessDevicesSearchPlaceholder) }),
        proxyUser && React.createElement(CreateAccessDevice, { community: community }),
        isSeamAvailable && React.createElement(ImportAccessDevices, { community: community })));
};
export default AccessDevicesTabAction;
